import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { getReportConfigItem } from './helper/getReportConfigs';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { WFormFieldRichText, WFormFieldText } from '../../core/forms/WFormFramework';

interface DatenauswertungReportKonfigurationBemerkungProps extends React.ClassAttributes<any> {
    data: any;
    standort: number;
    type: string;
    sub?: string;
    onClose: () => void;
}

interface DatenauswertungReportKonfigurationBemerkungState {
    config: any;
    curNode: number;
}

export class DatenauswertungReportKonfigurationBemerkung extends
    React.Component<DatenauswertungReportKonfigurationBemerkungProps, DatenauswertungReportKonfigurationBemerkungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            config: null,
            curNode: null
        };
        this.onClickSave = this.onClickSave.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.setConfig();
    }

    onChangeActive(event: any): void {
        const config: any = this.state.config || {};
        const index: number = +event.target.value || 0;
        const checked: boolean = !!event.target.checked;
        const selection: any[] = config.selection || [];
        const node: any = selection[index] || {};
        node.active = checked;
        this.setState({ config: { ...config, selection } });
    }

    onChangeBemerkung(data: string): void {
        const config: any = this.state.config || {};
        const selection: any[] = config.selection || [];
        const node: any = selection[this.state.curNode] || {};
        node.bemerkung = data;
        this.setState({ config: { ...config, selection } });
    }

    onClickSave(): void {
        if (typeof (this.state.config || {}).tid !== 'undefined') {
            const name: string = (this.state.config || {}).name || '';

            if (confirm(`Konfiguration [${name}] wirklich überschreiben?`)) {
                this.setData(name);
            }
        } else {
            let name: string = null;

            do {
                name = prompt(i18n('Konfigurationsname', 'sys'), new Date().toLocaleString());
            } while (!(name || '').trim().length && name !== null);

            if (name === null) {
                return;
            }

            if (!((((this.state.config || {}).selection || [])[this.state.curNode] || {}).bemerkung || '').trim().length) {
                alert(i18n('Anzeige im PDF-Dokument', 'sys'));
                return;
            }
            this.setData(name);
        }
    }

    render(): JSX.Element {
        if (!Object.keys(this.state.config || {}).length || this.state.curNode === null) {
            return null;
        }

        return (
            <>
                {this.renderBemerkung()}
                <div
                    style={{
                        backgroundColor: 'var(--color-section-main)', width: '100%', bottom: 0, paddingLeft: 10,
                        borderBottomRightRadius: 'var(--border-radius-dialog)', borderBottomLeftRadius: 'var(--border-radius-dialog)',
                        boxSizing: 'border-box', position: 'absolute', display: 'flex', flexDirection: 'row'
                    }}>
                    {this.renderSaveButton()}
                </div>
            </>
        );
    }

    renderBemerkung(): JSX.Element {
        return (
            <WFormFieldText
                label={
                    <div style={{ margin: 10, marginBottom: 0, marginLeft: 6, display: 'flex', alignItems: 'center' }}>
                        <input
                            id='bemerkung-active'
                            type='checkbox'
                            value={this.state.curNode}
                            checked={this.state.config.selection[this.state.curNode].active}
                            onChange={(event: any) => this.onChangeActive(event)}
                        />
                        <label htmlFor='bemerkung-active'>
                            {i18n('Anzeige im PDF-Dokument', 'sys')}
                        </label>
                    </div>
                }
                key='bemerkung'
                name='bemerkung'
                customStyle={{ classInput: { width: 600, margin: 10, marginTop: 0 }, styleTextarea:  { width: '100%', height: 150 } }}
                value={this.state.config.selection[this.state.curNode].bemerkung}
                isTextarea
                onValueChange={(name: string, value: string) => this.onChangeBemerkung(value)}
            />
        );
    }

    renderSaveButton(): JSX.Element {
        return (
            <WActionButton
                label={i18n('Speichern', 'sys')}
                insideText={i18n('Speichern', 'sys')}
                key='save'
                action='save'
                styleProps={{ margin: 0, borderBottomLeftRadius: 'var(--border-radius-dialog)' }}
                onAction={this.onClickSave}
            />
        );
    }

    setConfig(): any {
        getReportConfigItem({
                data: (this.props.data || {})[IDs.ENT_REPORT] || [],
                standort: this.props.standort,
                key: this.props.type,
                sub: this.props.sub
            },
            (data: any, config: any, index: number) => {
                config = config || {};

                if (!(config.selection || []).length) {
                    config.selection = [];
                }

                if (typeof index !== 'number') {
                    config.selection.push({
                        standort: +this.props.standort || 0,
                        key: this.props.type || null,
                        ...(this.props.sub && { sub: this.props.sub }),
                        active: true,
                        checked: true,
                        bemerkung: null
                    });
                    index = config.selection.length - 1;
                }
                this.setState({ config, curNode: index });
            }
        );
    }

    setData(name: string): void {
        let config: any = this.state.config || {};
        const selection: any[] = config.selection || [];
        const tid: number = config.tid || null;

        if (!selection.length) {
            return;
        }
        this.dataService.setData(
            IDs.MOD_ETOOL, IDs.ENT_REPORT,
            { tid, name, konfiguration: JSON.stringify({ selection }) },
            (insertID: number) => {
                config = { ...config, ...(typeof insertID === 'number' && { tid, name }) };
                this.setState(
                    { config },
                    () => {
                        this.triggerService.fire('reload', IDs.ENT_REPORT);
                        const contextConfig: any = this.contextService.get('report_config') || {};
                        const curConfig: number = typeof contextConfig.curConfig === 'number' ? contextConfig.curConfig : null;

                        if (tid && tid === ((contextConfig.configs || [])[curConfig] || {}).tid) {
                            this.contextService.set('report_config', undefined);
                        }
                        this.props.onClose();
                    }
                );
            }
        );
    }
}
